import { Container, Heading, Link,Paragraph, TitleContent } from '@koaly/koaly-ui';
import { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';
import styled from 'styled-components';

import { Footer } from '../components/Footer/Footer';
import { FooterCTAWaitingList } from '../components/FooterCTAWaitingList/FooterCTAWaitingList';
import { TopBar } from '../components/TopBar/TopBar';

const ContentContainer = styled.div`
  max-width: 520px;
  margin: 0 auto;
`;

export const Contact: NextPage = () => {
  return (
    <React.Fragment>
      <Head>
        <title>Contact - Koaly</title>
      </Head>
      <Container>
        <TopBar spaceAfter={40} />
        <TitleContent title="Contact" titleSize="mega" align="center" spaceAfter={36} />
        <ContentContainer>
          <Heading size="h2" spaceAfter={12}>
            Gegevens
          </Heading>
          <Paragraph spaceAfter={40}>
            <b>Adres</b> <br />
            De Hooght 58 <br />
            3353 CP Papendrecht <br />
            <b>E</b>: <Link href="mailto:info@koaly.nl">info@koaly.nl</Link> <br />
            <b>T</b>: <Link href="tel:0031787990046">+31 (0)78 799 0046</Link> <br />
            <br />
            <b>KVK/BTW</b>
            <br />
            KVK-nummer: 60514612 <br />
            BTW-nummer: NL002300806B88 <br />
          </Paragraph>
        </ContentContainer>
      </Container>
      <Container background={true} variant="secondary">
        <FooterCTAWaitingList />
      </Container>
      <Container>
        <Footer />
      </Container>
    </React.Fragment>
  );
};

export default Contact;
